<div class="flex flex-col gap-5">
	<div class="flex align-middle justify-between">
		<h4>{{ headingText }}</h4>
		<div *ngIf="!hideRestoreDefaults">
			<app-button btn="secondary" size="small" (click)="reset()"
				>Reset to default</app-button
			>
		</div>
	</div>
	<div>
		<h5 class="mb-2 font-bold">Unit of length</h5>
		<app-radio-group
			(ngModelChange)="unitChange($event)"
			[ngModel]="margins.unit"
			[items]="UnitOptions"
			type="compact"
			class="mb-5"
		></app-radio-group>
		<ng-container *ngIf="useHtmlDocuments$ | async">
			<h5 class="mb-2 font-bold">Paper size</h5>
			<app-radio-group
				(ngModelChange)="pageSizeChange($event)"
				[ngModel]="pageSize"
				[items]="PageSizeOptions"
				type="compact"
				class="mb-5"
			></app-radio-group>
		</ng-container>

		<h5 class="mb-2 font-bold">Margins</h5>
		<div class="flex justify-between gap-3">
			<app-input label="Top" [(ngModel)]="margins.top"></app-input>
			<app-input label="Bottom" [(ngModel)]="margins.bottom"></app-input>
			<app-input label="Left" [(ngModel)]="margins.left"></app-input>
			<app-input label="Right" [(ngModel)]="margins.right"></app-input>
		</div>
	</div>
	<hr />
	<div class="flex align-middle justify-between">
		<app-button btn="secondary" (click)="cancel()">Cancel</app-button>
		<app-button btn="primary" (click)="save()">Apply changes</app-button>
	</div>
</div>
